/**
 * user sentiment question
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import { TextAreaInput, TextInput } from '../../../global/components/forms/index.js'; 

import contentModuleStyles from '../contentModuleModuleStyles.css';

class UserSentimentQuestion extends Base {
  constructor(props) {
    super(props);
    this.state = {
      showElaborate: false
      , placeholder: "Tell us more!"
    }
    this._bind(
      '_toggleShowElaborate'
      , '_handleRatingChange'
      , '_handleFormChange'
    )
  }

  _toggleShowElaborate() {
    this.setState({showElaborate: !this.state.showElaborate}); 
  }

  _handleRatingChange(target, rating, type) {
    if(type == 'thumbs') {
      this.props.handleRatingChange(target, rating); 
      this.setState({placeholder: rating == 2 ? "Feedback/Comments?" : "Tell us more!", showElaborate: true}); 
    } else if(type == 'stars') {
      this.props.handleRatingChange(target, rating); 
      this.setState({placeholder: (rating > 0 && rating < 5) ? "Feedback/Comments?" : "Tell us more!", showElaborate: true}); 
    } else if(type == 'confidence') {
      this.props.handleRatingChange(target, rating); 
      this.setState({placeholder: (rating > 0 && rating < 8) ? "Feedback/Comments?" : "Tell us more!", showElaborate: true}); 
    } else { 
      this.props.handleRatingChange(target, rating); 
    }
  }

  _handleFormChange(e) {
    this.props.handleFormChange(e); 
  }

  render() {
    const { question, userSentimentQuestion } = this.props;
    const { showElaborate, placeholder } = this.state; 

    const generalOptions = [1, 2, 3, 4, 5]; 
    const confidenceOptions = Array.from({length: 10}, (_, i) => i + 1); 
    
    if(question.ratingType == 'thumbs') {
      return (
        <div className="yt-col full" style={{paddingBottom: 25, paddingLeft: 10, paddingRight: 10}}>
          <p style={{textAlign: 'center'}}>{question.text}</p>
          <div className="yt-row center-horiz">
            <button className="rating-btn" onClick={userSentimentQuestion && userSentimentQuestion.rating == 1 ? () => this._handleRatingChange(`userSentiment.${question._id}.rating`, -1, 'thumbs') : () => this._handleRatingChange(`userSentiment.${question._id}.rating`, 1, 'thumbs')}>
              <img style={{height: 20, width: 20, color: '#fff', marginRight: 15}} src={userSentimentQuestion && userSentimentQuestion.rating == 1 ? '/img/thumbs_up_filled.png' : '/img/thumbs_up.png'}/>
            </button>
            <button className="rating-btn" onClick={userSentimentQuestion && userSentimentQuestion.rating == 2 ? () => this._handleRatingChange(`userSentiment.${question._id}.rating`, -1, 'thumbs') : () => this._handleRatingChange(`userSentiment.${question._id}.rating`, 2, 'thumbs')}>
              <img style={{height: 20, width: 20, color: '#fff', marginLeft: 15}} src={userSentimentQuestion && userSentimentQuestion.rating == 2 ? '/img/thumbs_down_filled.png' : '/img/thumbs_down.png'}/>
            </button>
          </div>
          { showElaborate && userSentimentQuestion.rating > 0 ? 
            <div className="free-text-input" style={{paddingTop: 10}}>
              <TextAreaInput
                change={this._handleFormChange}
                placeholder={placeholder}
                maxLength="250"
                name={`userSentiment.${question._id}.freeText`}
                required={false}
                rows="1"
                value={userSentimentQuestion.freeText}
              />
            </div>
          : null
          }
        </div>
      )
    } else if(question.ratingType == 'stars') {
      return (
        <div className="yt-col _50" style={{paddingBottom: 25, paddingLeft: 10, paddingRight: 10}}>
          <p>{question.text}</p>
          <div className="yt-row">
            { generalOptions.map((option, i) => 
              <div>
                { userSentimentQuestion && userSentimentQuestion.rating === i + 1 ? 
                  <button className="rating-btn" onClick={() => this._handleRatingChange(`userSentiment.${question._id}.rating`, -1, 'stars')}>
                    <img style={{height: 25, width: 25, color: '#fff'}} src={'/img/star_filled.png'}/>
                  </button>
                :
                  <button className="rating-btn" onClick={() => this._handleRatingChange(`userSentiment.${question._id}.rating`, i + 1, 'stars')}>
                    <img style={{height: 25, width: 25, color: '#fff'}} src={userSentimentQuestion && userSentimentQuestion.rating >= i + 1 ? '/img/star_filled.png' : '/img/star.png'}/>
                  </button>
                }
              </div>
            )}
          </div>
          { showElaborate && userSentimentQuestion.rating > 0 ? 
            <div className="free-text-input">
              <TextAreaInput
                change={this._handleFormChange}
                placeholder={placeholder}
                maxLength="250"
                name={`userSentiment.${question._id}.freeText`}
                required={false}
                rows="1"
                value={userSentimentQuestion.freeText}
              />
            </div>
          : null
          }
        </div>
      )
    } else if(question.ratingType == 'confidence') {
      return (
        <div className="yt-col full" style={{paddingBottom: 10, paddingLeft: 10, paddingRight: 10}}>
          <p>{question.text}</p>
          <div className="yt-row center-horiz space-between u-centerText">
            {confidenceOptions.map((option, i) =>
              <div>
                { userSentimentQuestion && userSentimentQuestion.rating === i + 1 ? 
                  <button onClick={() => this._handleRatingChange(`userSentiment.${question._id}.rating`, -1, 'confidence')} className="confidence-btn -selected center-vert">
                    <p style={{paddingTop: 4}}>{option}</p>
                  </button>
                : 
                  <button onClick={() => this._handleRatingChange(`userSentiment.${question._id}.rating`, i + 1, 'confidence')} className="confidence-btn center-vert">
                    <p style={{paddingTop: 4}}>{option}</p>
                  </button>
                }
              </div>
            )}
          </div>
          { showElaborate && userSentimentQuestion.rating > 0 ? 
            <div className="free-text-input" style={{paddingTop: 20}}>
              <TextAreaInput
                change={this._handleFormChange}
                placeholder={placeholder}
                maxLength="250"
                name={`userSentiment.${question._id}.freeText`}
                required={false}
                rows="1"
                value={userSentimentQuestion.freeText}
              />
            </div>
          : null
          }
        </div>
      )
    } else null
  }
}

UserSentimentQuestion.propTypes = {
  question: PropTypes.object.isRequired
  , handleChange: PropTypes.func.isRequired
  , userSentiment: PropTypes.object.isRequired 
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    sentimentQuestionStore: store.sentimentQuestion
  }
}

export default connect(
    mapStoreToProps
  )(UserSentimentQuestion);



// WEBPACK FOOTER //
// modules/contentModule/components/UserSentimentQuestion.js.jsx